import { render, staticRenderFns } from "./CarbonSegments.vue?vue&type=template&id=3e8d5fa0&"
import script from "./CarbonSegments.vue?vue&type=script&lang=js&"
export * from "./CarbonSegments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports